import { useMutation, useQueryClient } from '@tanstack/react-query'
import { removeRuleJurisdiction } from 'api/wage/removeRuleJurisdiction'
import { wageRuleKeys } from './keys'

export const useRemoveRuleJurisdictionMutation = (ruleId: number) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (request: Parameters<typeof removeRuleJurisdiction>[0]) =>
      removeRuleJurisdiction(request),
    onSuccess: () => {
      return queryClient.invalidateQueries({
        queryKey: wageRuleKeys.byId(ruleId),
      })
    },
  })
}
